import { FC } from 'react';
import styled from '@emotion/styled';

interface CoaProvidedBannerProps {
  coa_provided_banner_image_url: string;
}

export const CoaProvidedBanner: FC<React.PropsWithChildren<CoaProvidedBannerProps>> = ({
  coa_provided_banner_image_url,
}) => {
  return (
    <Wrapper>
      <Image src={coa_provided_banner_image_url} alt='coa-provided-banner' />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 0;
`;

const Image = styled.img`
  width: 100%;
  object-fit: fill;
`;
